import firebaseLoginEmail from './firebaseLoginEmail'
import firebaseLoginGoogle from './firebaseLoginGoogle'
import firebaseLogout from './firebaseLogout'

const AuthService = {
  firebaseLoginEmail,
  firebaseLoginGoogle,
  firebaseLogout,
}

export default AuthService
